<template>
  <Layout>
    <PageHeader v-if="title" :items="items" :title="title"/>
    <ticket-create-modal
        id="ticket-create-modal"
        :key="`ticket-create-modal`"
        @created="onTicketCreated"
    ></ticket-create-modal>
    <div v-if="stats.length" class="row">
      <div v-for="stat of stats" :key="stat.icon" class="col-6 col-md-4 col-xl-3">
        <Stat :loading="busy" v-bind="stat"/>
      </div>
    </div>
    <div v-if="!lodash.isEmpty(filterColumns)" class="row">
      <model-filter
          v-model="filter"
          :columns="filterColumns"
          :filterHandler="filterHandler"
          :modelVariable="modelVariable"
      />
    </div>
    <div class="row">
      <model-index
          ref="table"
          :busy.sync="busy"
          :card-title="lodash.startCase('daftar folder')"
          :columns="columns"
          :filter-params.sync="filterParams"
          :from="from"
          :loading="loading"
          :models-paginated="modelsPaginated"
          :page.sync="page"
          :per-page.sync="perPage"
          :search.sync="search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :total="totalFiltered"
          class="col-12"
          v-bind="modelIndexProps"
          @create-click="handleCreate"
          @export-click="handleExport"
          @show-click="handleShow"
          @edit-click="handleEdit"
          @delete-click="handleDelete"
      >
      </model-index>
    </div>
  </Layout>
</template>

<script>
import ModelFilter from "@/router/views/tickets/filter";
import ModelIndex from "../models/index-v3";
import TicketCreateModal from "@/components/modals/ticket-create.vue";
import StatusWidget from "@/components/widgets/statuses/status.vue";
import PageHeader from "@/components/page-header";
// eslint-disable-next-line no-unused-vars
import {lowerCase, toLower} from "lodash";

export default {
  extends: ModelIndex,
  components: {
    TicketCreateModal,
    ModelFilter,
    PageHeader
  },
  page: {
    title: "Tickets"
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("menuitems.tickets.text"));
      }
    },
    resourceRoute: {default: "tickets"},
    modelVariable: {default: "ticket"},
    denyCreate: {
      type: Boolean,
      default() {
        return !this.$auth.hasPermissionTo('tickets.create');
      }
    }
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t("tickets.plural")),
      items: [
        {
          text: this.lodash.startCase(this.$t("tickets.singular")),
          href: "/tickets",
          active: true
        }
      ],
      allowedActions: null,
      sortBy:
          (this.$route.query.sort &&
              this.$route.query.sort
                  .split("|")
                  .shift()
                  .split(",")
                  .shift()) ||
          "id",
      sortDesc:
          (this.$route.query.sort &&
              this.$route.query.sort
                  .split("|")
                  .shift()
                  .split(",")
                  .pop() === "desc") ||
          true,
      filterColumns: {
        id__in: {
          type: Array,
          label: this.lodash.startCase(this.$t("tickets.id")),
          operator: "in",
          input_component: "ticket-multiselect-ajax"
        },
        created_by: {
          type: Number,
          label: this.lodash.startCase(this.$t("tickets.created_by")),
          operator: "eq",
          input_component: "user-select-ajax"
        },
        created_at__between: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("tickets.created_at")),
          operator: "between",
          input_component: "datepicker-range"
        },
        customer_type: {
          type: String,
          label: this.lodash.startCase(this.$t("tickets.customer_type")),
          operator: "eq",
          input_component: "customer-type-select"
        },
        status: {
          type: String,
          label: this.lodash.startCase(this.$t("tickets.status")),
          operator: "eq",
          input_component: "ticket-status-select"
        }
        // 'purchase_order_payment_status': {
        //   type: Array,
        //   label: this.lodash.startCase('Status Pembayaran Pembelian'),
        //   input_component: 'purchase-order-payment-status-select',
        // },
      }
    };
  },
  computed: {
    modelIndexProps() {
      return {
        ...this.$props,
        denyCreate: this.denyCreateFromAllowedActions(),
      };
    },
    columns() {
      return {
        ["ticket"]: [
          {
            key: "index",
            label: "No"
          },
          {
            key: "id",
            label: this.lodash.startCase(this.$t("tickets.ticket_id")),
            tdClass: "text-left",
            thStyle: {minWidth: "100px"},
            sortable: true,
            component: {
              props: ["item"],
              computed: {
                formated_id() {
                  return `${this.item.id}: ${this.$t(`tickets.customer_types.${this.item.customer_type}`)}`;
                }
              },
              template: `
                <div>
                  <router-link :to="'/tickets/'+item.id">
                    {{ formated_id }}
                  </router-link>
                </div>
              `
            }
          },
          {
            key: "created_at",
            label: this.lodash.startCase(this.$t("tickets.created")),
            thStyle: {minWidth: "125px"},
            sortable: true,
            component: {
              props: ["item"],
              template:
                  "<div>{{item.creator.name}} <br/> ({{$moment.utc(item.created_at).local().format('DD MMM YYYY')}})</div>"
            }
          },
          {
            key: "brs_lcs",
            label: "Mitra",
            thStyle: {minWidth: "150px"},
            component: {
              props: ["item"],
              template: `
                <div>
                  <router-link v-if="item.brs_lcs.id" :to="'/customers/'+item.brs_lcs.id">{{ item.brs_lcs.name }}
                  </router-link>
                  <span v-else>-</span>
                </div>
              `
            }
          },
          {
            key: "purchase_order_total_quantity",
            thStyle: {minWidth: "125px"},
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.purchase_order_total_biomass`)),
            tdClass: "text-end",
            sortable: true,
            formatter: value =>
                value >= 500
                    ? `${this.$numeral(value / 1000).format("0,0.[00]")} ${this.$t("units.ton")}`
                    : `${this.$numeral(value).format("0,0.[00]")} ${this.$t("units.kg")}`
          },
          {
            key: "purchase_order_untransported_biomass",
            thStyle: {minWidth: "125px"},
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.purchase_order_total_available_quantity`)),
            tdClass: "text-end",
            sortable: true,
            // formatter: value => value >= 500 ? `${this.$numeral(value / 1000).format('0,0.[000]')} ${this.$t('units.ton')}` :
            //     `${this.$numeral(value).format('0,0.[000]')} ${this.$t('units.kg')}`,
            component: {
              props: ["item"],
              computed: {
                available_quantity() {
                  if (this.item.purchase_orders.length === 0 || this.item.customer_type === "brs") {
                    return "-";
                  }
                  return this.item.purchase_order_total_available_quantity >= 500
                      ? `${this.$numeral(this.item.purchase_order_total_available_quantity / 1000).format(
                          "0,0.[000]"
                      )} ${this.$t("units.ton")}`
                      : `${this.$numeral(this.item.purchase_order_total_available_quantity).format(
                          "0,0.[000]"
                      )} ${this.$t("units.kg")}`;
                }
              },
              template: "<div>" + "<div>{{available_quantity}}</div>" + "</div>"
            }
          },
          {
            key: "purchase_order_total",
            thStyle: {minWidth: "125px"},
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.purchase_order_total_price`)),
            tdClass: "text-end",
            sortable: true,
            formatter: value => this.$numeral(value).format("$ 0,0")
          },
          // {
          //   key: 'purchase_orders',
          //   label: this.lodash.startCase(this.$t('purchase_payments.singular')),
          //   thStyle: { minWidth: '50px' },
          //   component: {
          //     props: ['item'],
          //     computed: {
          //       purchaseOrder() {
          //         return this.lodash.flatten(this.item.purchase_orders.map(i => i.payments)).length
          //       }
          //     },
          //     template: '<div>' +
          //         '<div v-if="purchaseOrder"><i class="fa fa-check text-success m-2"  style="color: blue"></i>{{ purchaseOrder }}</div>' +
          //         '<div v-else><i class="fa fa-times text-danger m-2" style="color: red;"></i></div>' +
          //         '</div>'
          //   }
          // },
          {
            key: "status",
            label: this.lodash.startCase(this.$t("tickets.status")),
            thStyle: {minWidth: "50px"},
            formatter: value => this.lodash.startCase(this.$t(`tickets.statuses.${value}`))
          },
          {
            key: "action",
            label: this.$t("Action"),
            class: "text-center",
            style: {width: "15%"}
          }
        ]
      };
    }
  },
  methods: {
    onTicketCreated(event) {
      this.$router.push({
        path: "/purchase_orders/create",
        query: {
          ticket_id: event.id
        }
      });
    },
    handleCreate() {
      this.$bvModal.show("ticket-create-modal");
    },
    getModelName(value) {
      return value["order_id"];
    },
    getAllowedActions(model) {
      return Array.isArray(model?.allowed_actions) ? model.allowed_actions : [];
    },
    hasBackendAllowedActions(model) {
      return Array.isArray(model?.allowed_actions);
    },
    allowedActionNames(action) {
      return {
        edit: ["edit", "update"],
        delete: ["delete", "destroy"],
        show: ["show", "view"],
      }[action] || [action];
    },
    hasAllowedAction(model, action) {
      const allowedActions = this.getAllowedActions(model);
      return this.allowedActionNames(action).some(name => allowedActions.includes(name));
    },
    denyCreateFromAllowedActions() {
      if (!Array.isArray(this.allowedActions)) {
        return this.denyCreate;
      }

      return !(this.allowedActions.includes("create") || this.allowedActions.includes("store"));
    },
    delete(value) {
      return this.$axios.delete(`/tickets/${this.getModelKey(value)}`);
    },
    fetchModels(page = 1) {
      return this.$axios
          .get("/tickets", {
            params: {
              with: [
                "purchase_orders.odoo_purchase_order.odoo_purchase_order_lines",
                "purchase_orders.customer",
                "purchase_orders.product",
                "sale_orders.payments",
                "creator"].join(',')
              ,
              page: page,
              per_page: this.perPage,
              search: this.search,
              sort: `${this.sortBy},${this.sortDesc ? "desc" : "asc"}`,
              left_join_ticketable: "all",
              ...this.filterParams
            }
          })
          .then(response => {
            const {
              data: {data, meta}
            } = response;
            this.allowedActions = Array.isArray(meta?.allowed_actions) ? meta.allowed_actions : null;
            this.models = data.map(datum => ({
              ...datum,
              purchase_orders_2: datum.purchase_orders,
              brs_lcs: datum.purchase_orders.length ? datum.purchase_orders[0].customer : "-",
              ...this.modelPolicy(datum)
              // _denyEdit: datum.purchase_orders.length > 0,
            }));
            this.page = Number(meta.current_page);
            this.perPage = Number(meta.per_page);
            this.from = Number(meta.from);
            this.total = Number(meta.total);

            this.stats = [
              {
                title: this.lodash.startCase(this.$t("tickets.count")),
                value: this.$numeral(meta.total).format("0,0"),
                valueTitle: this.$numeral(meta.total).format("0,0"),
                wrapperClass: "col-12 col-md-6 col-xl-4",
                component: StatusWidget
              }
            ];

            return response;
          })
          .catch(error => this.failedAlert(error));
    },
    modelPolicy(model) {
      if (this.hasBackendAllowedActions(model)) {
        return {
          _denyEdit: !this.hasAllowedAction(model, "edit"),
          _denyDelete: !this.hasAllowedAction(model, "delete"),
          _denyShow: !this.hasAllowedAction(model, "show")
        };
      }

      let _modelPolicy = {
        _denyShow: false,
        _denyEdit: false,
        _denyDelete: true
      };
      if (!this.$auth.hasPermissionTo("tickets.edit")) {
        _modelPolicy._denyEdit = true;
      } else if (model.creator.email !== this.$auth.user().email || model.purchase_orders.length > 0) {
        _modelPolicy._denyEdit = true;
      }

      return _modelPolicy;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .table-model {
    tbody tr td,
    tbody tr td > * {
      font-size: 12px !important;
    }

    td,
    th {
      vertical-align: middle !important;
    }
  }

  h4.page-title {
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 800;
    line-height: 20px; /* 125% */
    letter-spacing: 0.8px;
    color: #0f172a;
    padding-bottom: 0;
  }

  .page-title-box {
    padding-bottom: 20px;
  }
}
</style>
